import {
  JoiningPageTranslationsService,
  NavigationService,
} from "translations";
import {
  FacetService,
  LiteAgentService,
  MonickerService,
  ProfileService,
} from "shared-services";

import { config } from "../config/common";
import { UserAccountService } from "./user-account-service";
import { WebMediaService } from "./webmedia-service";

export const userAccountService = new UserAccountService({
  url: config.userAccountApiUrl,
});

export const webMediaService = new WebMediaService({
  url: config.webMediaApiUrl,
});

// initialise shared services
export const navigationService = new NavigationService({
  url: config.umbracoApiUrl,
});

export const joiningPageTranslationsService =
  new JoiningPageTranslationsService({ url: config.umbracoApiUrl });

export const profileService = new ProfileService({
  url: config.profileApiRoot,
});

export const facetService = new FacetService({ url: config.profileApiRoot });

export const nameCheckingService = new MonickerService({
  url: config.monickerApiUrl,
});

export const agentsService = new LiteAgentService({
  url: config.liteAgentApiUrl,
});
